module.exports = __webpack_public_path__ + "img/ysgj_037@2x.5ed418ad.png";